const ShareIcon = () => {
  return (
    <svg
      width="19"
      height="22"
      viewBox="0 0 19 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3333 4.88889L6.66667 8.77778M12.3333 17.1111L6.66667 13.2222M6.66667 11C6.66667 12.5341 5.39814 13.7778 3.83333 13.7778C2.26853 13.7778 1 12.5341 1 11C1 9.46589 2.26853 8.22222 3.83333 8.22222C5.39814 8.22222 6.66667 9.46589 6.66667 11ZM18 18.2222C18 19.7563 16.7315 21 15.1667 21C13.6019 21 12.3333 19.7563 12.3333 18.2222C12.3333 16.6881 13.6019 15.4444 15.1667 15.4444C16.7315 15.4444 18 16.6881 18 18.2222ZM18 3.77778C18 5.3119 16.7315 6.55556 15.1667 6.55556C13.6019 6.55556 12.3333 5.3119 12.3333 3.77778C12.3333 2.24366 13.6019 1 15.1667 1C16.7315 1 18 2.24366 18 3.77778Z"
        stroke="#4D4D4D"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default ShareIcon;
